import { useState } from "react";
import { FileDown, FileSpreadsheet, FileText } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/kit";
import { useWs } from "@/context/WorkspaceContext";
import { download, errMsg } from "@/lib/api";

const ITEMS = [
  ["pdf", FileText, "Relatório executivo (PDF)", "Diagnóstico, score, alertas, prioridades, planejamento 12m/5a/30a, patrimônio, dívidas, metas, cronograma e movimentações.", "reports/pdf", "prospera-relatorio.pdf"],
  ["xlsx", FileSpreadsheet, "Planilha completa (Excel)", "Abas de diagnóstico, movimentações, patrimônio, dívidas, metas, projeção de 30 anos e cronograma.", "reports/xlsx", "prospera-planilha.xlsx"],
  ["csv", FileDown, "Movimentações (CSV)", "Exportação simples das receitas e despesas para importação em outros sistemas.", "export.csv", "movimentacoes.csv"],
];

export default function Relatorios() {
  const { wid, ws } = useWs();
  const [busy, setBusy] = useState(null);
  const get = async (key, path, name) => {
    setBusy(key);
    try { await download(`/workspaces/${wid}/${path}`, name); toast.success("Download iniciado"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <div data-testid="relatorios-page">
      <PageHeader eyebrow="Relatórios" title={`Relatórios · ${ws?.name || ""}`} subtitle="Gere documentos profissionais com os dados do espaço selecionado." />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {ITEMS.map(([key, I, title, desc, path, name]) => (
          <div key={key} className="card-p flex flex-col p-6 hover:-translate-y-1">
            <I className="h-8 w-8 text-[#D4AF37]" />
            <h3 className="mt-4 text-lg font-semibold">{title}</h3>
            <p className="mt-2 flex-1 text-sm text-slate-400">{desc}</p>
            <Button className="mt-6" disabled={busy === key} onClick={() => get(key, path, name)} data-testid={`download-${key}-btn`}>{busy === key ? "Gerando..." : "Baixar"}</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
